import { useNavigate, useLocation, useParams } from 'react-router-dom';

import useAuth from '../hooks/useAuth';

import Header from './Header'
import Knoppie from './Knoppie'
import Employees from'../../src/images/Employees.png'
import Injuries from'../../src/images/Injuries.png'
import NoImage from'../../src/images/no-image.png'


const PayrollSettings = () =>{
const location = useLocation();
        const auth = useAuth();
        const username = auth.auth.user.username
        const access = auth.auth.user.userRole
        const from = location.state?.from || './'
    return (
        <>
        <Header username={username} role={access} destination={from}></Header>
        <div>Payroll Index</div>
        {access==="administrator"||"manager"?
        (
        <>
        <Knoppie
        clickable={true}
        image={NoImage}
        from={'../PayrollSettings'}
        text={"Paytypes"}
        destination={"../PaytypesList"}
        
        />
        <Knoppie
        clickable={true}
        image={NoImage}
        from={'../PayrollSettings'}
        text={"Payrates"}
        destination={"../PayratesList"}
        
        
        />
        <Knoppie
        clickable={true}
        image={NoImage}
        from={'../PayrollSettings'}
        text={"Additions"}
        destination={"../AdditionsList"}
        
        
        />
        
       
    </>
    ):
        ("")}



        </>
    )

}

export default PayrollSettings